<div>
  <router-outlet></router-outlet>
</div>
<ngx-spinner type="ball-scale-multiple" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="var(--e-global-color-text-opposite)" [fullScreen]="true">
  <p style="color: white"> {{ 'common.loading' | translate }} </p>
</ngx-spinner>
